import Box from '@mui/material/Box'
import styled from '@mui/material/styles/styled'

interface Props {
    children?: React.ReactNode
    labelColon?: boolean
}

export const StartLabelFieldsContainer = styled(Box)<Props>`
    display: grid;
    grid-template-columns: minmax(10%, 25%) auto;
    align-items: first baseline;
    grid-gap: ${({ theme }) => theme.spacing(1)};

    ${({ theme }) => theme.breakpoints.up('sm')} {
        font-size: 14px;
    }
    ${({ theme }) => theme.breakpoints.down('md')} {
        font-size: 10px;
    }

    ${({ labelColon }) =>
        labelColon
            ? `
      & > label:after {
        content: ':';
      }
  `
            : ''};
`

export default StartLabelFieldsContainer
export { StartLabelFieldsContainer as Container }
export type { Props as StartLabelFieldsContainerProps }
